module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "section",
    attrs: {
      "id": "sect8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/toc#sect8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cranberry Orange Scones")])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    staticStyle: {
      "height": "70vh"
    },
    attrs: {
      "alt": "",
      "src": "OEBPS/images/18-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "RecipebYieldb"
  }, [_vm._v("Yield: 8 scones | Prep Time: 15 minutes | Cook Time: 18–21 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "extract_r"
  }, [_vm._v("Scones are my go-to lazy Sunday morning breakfast food. I love to just sit out on the back deck, book in hand, as I get ready to take on the rest of the day. The use of whole wheat flour and low-fat buttermilk helps make this a lighter version than your typical scone. Feel free to substitute your favorite type of berry for the cranberries!")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_c('strong', [_vm._v("INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "Subheadb"
  }, [_c('strong', [_vm._v("Scones")])]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1½ cups whole wheat flour")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 tablespoon orange zest")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1½ teaspoons baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ teaspoon kosher salt")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("4 tablespoons cold unsalted butter, cubed")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ cup low-fat buttermilk")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("3 tablespoons maple syrup")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("3 tablespoons orange juice")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 teaspoon vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("¾ cup dried cranberries")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("2 teaspoons skim milk")]), _vm._v(" "), _c('p', {
    staticClass: "Subheadb"
  }, [_c('strong', [_vm._v("Glaze")])]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("¼ cup confectioners’ sugar")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1–2 tablespoons orange juice")]), _vm._v(" "), _c('p', {
    staticClass: "directions"
  }, [_c('strong', [_vm._v("DIRECTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("1. "), _c('em', [_vm._v("For the scones:")]), _vm._v(" Preheat the oven to 425°F. Line a baking sheet with parchment paper.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("2. In a medium bowl, combine the flour, orange zest, baking powder, and salt.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("3. Cut in the cold butter with a pastry cutter until the mixture forms fine clumps.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("4. Gently stir in the buttermilk, maple syrup, orange juice, and vanilla. Fold in the cranberries.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("5. Scoop the dough onto the baking sheet and shape the dough in a circle about ¾ inch thick. Brush the top with the milk. Slice the dough into 8 wedges.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("6. Bake for 18 to 21 minutes until the scones are golden and are cooked through.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("7. Let the scones cool on the baking sheet for 5 minutes, then transfer to a wire rack to cool further.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("8. "), _c('em', [_vm._v("For the glaze:")]), _vm._v(" Mix the confectioners’ sugar and orange juice until it reaches a smooth consistency. Drizzle over the cooled scones.")]), _vm._v(" "), _c('p', {
    staticClass: "notehead"
  }, [_c('strong', [_vm._v("VARIATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "NotebText"
  }, [_vm._v("Use fresh cranberries instead of dried.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-096877f3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/sect8.vue
// module id = 108
// module chunks = 0